import en from './locales/en/translation.json';
import it from './locales/it/translation.json';
import ar from './locales/ar/translation.json';

// the translations
export default {
  en: { translation: en },
  it: { translation: it },
  ar: { translation: ar },
};